export const dateRegex =
  /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/;

export const dateRegex1 =
  /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const timeRegex = /^([0-1]?[0-9]|2[0-4]):[0-5][0-9]$/;
export const phoneRegExp = /^[0-9]{10}$/;
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isDate = (date: string) => dateRegex.test(date);
export const isDate1 = (date: string) => dateRegex1.test(date);
export const isTime = (time: string) => timeRegex.test(time);
export const isEmail = (email: string) => emailRegExp.test(email);
